import { twMerge } from 'tailwind-merge'

type Props = {
  label: string
  disabled: boolean
  onClick: () => void
  className?: string
}

export const TagButton = ({ label, disabled, onClick, className }: Props) => {
  return (
    <button
      className={twMerge(`bg-tag text-style-accent py-1 px-2 rounded-lg ${className}`)}
      type="button"
      onClick={() => onClick()}
      disabled={disabled}
    >
      {label}
    </button>
  )
}
